import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { handleError } from '../../../components/errors/errorHandling';
import { Submissions } from '../../../models/submission/submission';
import { getSubmissionList } from '../../../services/form/FormService';
import { RootState } from '../../../store';

const useSubmissionList = (formId?: string, pageSize?: number) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [currentFormId, setCurrentFormId] = useState(formId);
  const [currentForm, setCurrentForm] = useState<any>();
  const [currentFormSteps, setCurrentFormSteps] = useState<any>();
  const [currentSubmissionList, setCurrentSubmissionList] = useState<Submissions[]>([]);
  const [currentFormName, setCurrentFormName] = useState<string>('');
  const [totalCount, setTotalCount] = useState<number>(0);
  const organizationId = useSelector((state: RootState) => state.organization.organization?.id);

  useEffect(() => {
    if (!currentFormId || !organizationId) {
      // TODO Set invalid properties
      return;
    }
    loadAsync(1);
  }, [currentFormId, organizationId]);

  const loadAsync = async (page = 1, query = '') => {
    try {
      if (organizationId && currentFormId) {
        setIsLoading(true);
        const { data } = await getSubmissionList(organizationId, currentFormId, query, page, pageSize || 12);
        if (data.submissions.data) {
          setCurrentSubmissionList(data.submissions.data);
        } else {
          setCurrentSubmissionList([]);
        }
        setCurrentFormName(data.form.name);
        setCurrentForm(data.form);
        setCurrentFormSteps(JSON.parse(data.form.content).steps);
        setTotalCount(data.submissions.totalCount);
      }
    } catch (error) {
      handleError(error);
    }
    setIsLoading(false);
  };

  return {
    currentSubmissionList,
    setCurrentFormId,
    currentFormName,
    isLoading,
    currentForm,
    currentFormSteps,
    totalCount,
    reloadSubmissions: loadAsync,
  };
};

export default useSubmissionList;
